import { Accordion, Button, Form } from "react-bootstrap";
import RefreshButton from "../../../../components/RefreshButton";
import useControlledList, { ControlledListFilterInput } from "../../../../hooks/useControlledList";
import { useAdminGetAllProcessorsQuery, useForceJobProcessingMutation } from "../../../../store/api/kinesense";
import ProcessorsList, { ProcessorsSortBy } from "./ProcessorsList";
import { useState } from "react";

export interface ControlledPropsListProps {
    maxItems?: number;
}

function ControlledProcessorsList(props: ControlledPropsListProps) {
    const control = useControlledList<ProcessorsSortBy>(ProcessorsSortBy.lastStartedAt, true);
    const { refetch, isFetching } = useAdminGetAllProcessorsQuery();
    const [jobId, setJobId] = useState<string>("");
    const [forceJobProcessing] = useForceJobProcessingMutation();

    const handleProcessJob = () => {
        console.log("Processing job:", jobId);
        forceJobProcessing({ jobId });
    };

    return (
        <article className="controlled-organisations-list">
            <section className="d-flex align-items-center justify-content-between">
                <Form onSubmit={(e) => e.preventDefault()}>
                    <ControlledListFilterInput
                        placeholder="Search by processor ID or instance type"
                        filter={control.filter}
                        handleOnChangeFilter={control.handleOnChangeFilter}
                    />
                </Form>

                <RefreshButton callback={refetch} isDisabled={isFetching} />
            </section>

            <ProcessorsList maxItems={props.maxItems} control={control} />

            <Accordion style={{ marginTop: "1rem" }}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Force job processing</Accordion.Header>
                    <Accordion.Body style={{ display: "flex", alignItems: "center" }}>
                        <Form.Control
                            value={jobId}
                            onChange={(e) => setJobId(e.target.value)}
                            type="text"
                            placeholder="Job ID"
                            style={{ display: "inline-block", width: "10rem" }}
                        />
                        <Button onClick={handleProcessJob} style={{ marginLeft: "1rem", display: "inline-block" }}>
                            Process
                        </Button>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </article>
    );
}

export default ControlledProcessorsList;
